import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const fontSize = [
  "xs",
  "sm",
  "base",
  "lg",
  "xl",
  "2xl",
  "3xl",
  "4xl",
  "5xl",
  "6xl",
  "7xl",
  "8xl",
];

const fontWeight = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
];

/**
 * `tailwind.config.ts` 의 커스텀 `aspectRatio` 키. tailwind-merge 는 **자기가 아는 값**
 * (`auto`·`square`·`video`·arbitrary)만 aspect 그룹으로 보므로, 커스텀 키를 등록하지
 * 않으면 `cn("aspect-game-card-vertical", "aspect-[96/144]")` 가 **둘 다 살아남는다.**
 *
 * 실측(#5415): `GameCard.Image` 가 기본으로 `aspect-game-card-vertical`(96/148)을 붙이고
 * 호출처가 `aspect-[159/238]`(데스크톱) · `aspect-[96/144]`(모바일)로 덮으려 했는데
 * **덮이지 않아** 카드가 각각 159×245 · 96×148 로 나왔다. 시안은 238 · 144 다.
 * 빌드·tsc·jest 는 전부 통과한다 — 픽셀로만 보이는 종류다(docs/pitfalls.md #8 과 같은 족).
 */
const aspectRatio = ["game-card-horizontal", "game-card-vertical"];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": fontSize.map((key) => `text-${key}`),
      "font-weight": fontWeight.map((key) => `font-${key}`),
      aspect: aspectRatio.map((key) => `aspect-${key}`),
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 홈페이지 내의 링크인지 확인
export function analyzeUrl(url?: string): {
  isOutbound: boolean;
  url: string | null;
} {
  if (!url) return { isOutbound: false, url: null };
  const _url = url.replace(
    /^https:\/\/(www\.)?(dev\.|staging\.)?bhaptics\.com/,
    "",
  );
  const isOutbound = _url.startsWith("http");
  return { isOutbound, url: _url };
}

// Check if video URL is valid
export function isValidVideoSrc(src: string | undefined): src is string {
  return !!src && src.trim() !== "";
}
